/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Cell.scss'
import React from 'react'

function Cell(props) {
  return <div className={`Cell ${props.className || ''}`}>{props.children}</div>
}

export default Cell
